import { useState } from "react";
import { useAuthenticatedApiClient } from "@/hooks/useAuthenticatedApiClient";
import FinancialApplicationApiClient from "@/api/financialApplicationApiClient";
import { ApplicationUserInviteReadDTO } from "@/types/ApplicationUserInviteReadDTO";

interface RenewInviteResponse {
  inviteId: string;
  inviteLink: string;
}

export const useRenewInvite = () => {
  const [isRenewing, setIsRenewing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const financialApplicationApiClient = useAuthenticatedApiClient(FinancialApplicationApiClient);

  const renewInvite = async (inviteId: string): Promise<RenewInviteResponse> => {
    setIsRenewing(true);
    setError(null);

    try {
      const response: ApplicationUserInviteReadDTO = await financialApplicationApiClient.renewInvite(inviteId);
      return {
        inviteId: response.id,
        inviteLink: response.inviteLink,
      };
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to renew invite";
      setError(errorMessage);
      throw err;
    } finally {
      setIsRenewing(false);
    }
  };

  return {
    renewInvite,
    isRenewing,
    error,
  };
};
